import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import styles from "@website/widget/login/components/header/header.module.scss";
import { HeaderPropertiesType } from "@website/widget/login/components/header/header.types";
import { FC, PropsWithChildren } from "react";
export const Header: FC<PropsWithChildren<HeaderPropertiesType>> = properties => {
  const $ = _c(12);
  const {
    className,
    id,
    title,
    onBack,
    onClose: onCloseModal
  } = properties;
  const t0 = `${styles.container} ${className ?? ""}`;
  const t1 = id ?? "";
  let t2;
  if ($[0] !== onBack) {
    t2 = onBack && <Button EndIcon={<MaterialIcon name="arrow_forward" />} color="neutral" equalDimension={true} onClick={onBack} variant="text" />;
    $[0] = onBack;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <h4 className={styles.title}>{title}</h4>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onCloseModal) {
    t4 = onCloseModal && <Button EndIcon={<MaterialIcon name="close" />} color="neutral" equalDimension={true} onClick={onCloseModal} variant="text" />;
    $[4] = onCloseModal;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className={t0} id={t1}>{t2}{t3}{t4}</div>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};